import controller from './differentialPressure.controller';

const template = require('./differentialPressure.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
